import React from "react";
import { getStatusDefinition } from "../../helpers/helpers";
import "./general-status-label.css";

/** label is the stored value; its text and color come from list. */
export default function GeneralStatusLabel({ label, list, marginLeft, className = "", style, as: Tag = "span", ...props }) {
  const status = getStatusDefinition(label, list);
  return <Tag {...props} className={`general-status-label ${status.statusColor || "gray"} ${className}`.trim()} style={{ ...style, ...(marginLeft !== undefined ? { marginLeft } : {}) }}>{status.label}</Tag>;
}
